import React from 'react';
import styled from 'styled-components';
import {
	AccentColor,
	OnAccentColor,
	Secondary800,
	DarkAccentColor,
	DisableColor,
	Grey300,
	Grey400,
	Grey900,
	ShadowColor
} from '../../Colors';

const BaseStyle = styled.button`
    text-decoration: none;
    text-transform: none;
    border-radius : 5px;
    padding : 0.5rem 1rem 0.5rem 1rem;
    &:focus{
        outline : 0;
    }
    &:disabled{
        border: none;
    }
`;

export const ContainedButtonBase = ({ ...props }) => <BaseStyle {...props} />;

const DefaultComponent = styled(ContainedButtonBase)`
    color : ${OnAccentColor};
    background-color : ${AccentColor};
    border: 1px solid ${AccentColor};
    box-shadow: 0px 2px 2px 0px ${ShadowColor};
    &:focus{
        background-color : ${Secondary800};
        border: 1px solid ${Secondary800};
    }
    &:hover{
        background-color : ${DarkAccentColor};
        border: 1px solid ${DarkAccentColor};
    }
    &:disabled{
        background-color : ${Grey300};
        color : ${DisableColor};
        border: none;
    }
`;

const GrayComponent = styled(ContainedButtonBase)`
    color : ${Grey900};
    background-color : ${Grey300};
    box-shadow: 0px 2px 2px 0px ${ShadowColor};
    border: none;
    &:focus{
        background-color : ${Grey400};
        border: none;
    }
    &:hover{
        background-color : ${Grey400};
        border: none;
    }
    &:disabled{
        background-color : ${Grey300};
        color : ${DisableColor};
        border: none;
    }
`;

const ContainedButton = ({ variant = 'default', ...props }) => {
	if (variant === 'default') {
		return <DefaultComponent {...props} />;
	}
	if (variant === 'gray') {
		return <GrayComponent {...props} />;
	}
	return null;
};

export default ContainedButton;